import CustomImage from '../../../v2-components/Antd/Image';

export const handlePharmacy = (iconUrl, product, className) => {
	if (!product.pharmacy) {
		return <label>{'   '}</label>;
	}

	if (product.pharmacy_image) {
		return (
			<>
				<label className="own-product-pharmacy-mobile">
					<CustomImage className={className} src={iconUrl ? iconUrl : 'https://storage.googleapis.com/tirx-resources-develop/817f55db-81a6-46a4-affd-ac46d05deaa0.png'} /> <span>{product.name_edited_pharmacy}</span>
				</label>
			</>
		);
	}

	return <label className="own-product-pharmacy-mobile">{product.name_edited_pharmacy}</label>;
};
